import { render } from "./TanpaBil.vue?vue&type=template&id=68e4bd3e"
import script from "./TanpaBil.vue?vue&type=script&lang=js"
export * from "./TanpaBil.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__